const html = require("choo/html");
const PanelElement = require("../elements/panel.js");
const Button = require("../elements/button.js");
const blankPanel = PanelElement({
  color: "purple",
  size: "small",
  children: [html``],
});
module.exports = function TutorialPanel(state, emit) {
  if (!state.currentTutorialCharIndex) {
    state.currentTutorialCharIndex = 0;
  }

  let tutorialFrame = 1;
  let imgSrc = "graphics/placeholder_ code_image.png";
  let currentStep = state.currentTutorial[state.currentTutorialStep];
  if (state.currentInterrupt) {
    currentStep = state.currentInterrupt;
  }
  if (!currentStep) {
    return blankPanel;
  }
  let isDone = false;
  let text = getParsedSubstring(
    currentStep.text,
    state.currentTutorialCharIndex
  );
  if (currentStep.text.length > state.currentTutorialCharIndex) {
    if (!state.charTickTimeout) {
      state.charTickTimeout = setTimeout(() => {
        emit("tutorial-char-tick");
      }, 25);
    }
    let mod = state.currentTutorialCharIndex % 10;
    if (mod < 5) {
      tutorialFrame = 1;
    } else {
      tutorialFrame = 2;
    }
    isDone = false;
  } else {
    clearTimeout(state.charTickTimeout);
    state.charTickTimeout = null;
    text = currentStep.text;
    isDone = true;
  }
  let nextButton;
  if (currentStep.hasNextButton && isDone) {
    let text = currentStep.nextButtonText || "Next";
    nextButton = Button({
      text,
      color: "purple",
      type: "tight halfwidth tutorial-button",
      onClick: () => {
        emit("tutorial-next-step");
      },
    });
  } else if (currentStep.isInterrupt) {
    // Don't show dismiss button for interrupts - users must use nextTriggers or reset/rewind
    nextButton = null;
  }

  return html`
    <div class="tutorial-panel">
    <div class="tutorial-text">
      <img
        src="/graphics/tutorial-portrait-${tutorialFrame}.png"
        alt="tutorial image"
        class="tutorial-portrait"
      />
      ${html([text])}
    </div>
      ${nextButton}
    </div>

    
  `;
};

function getParsedSubstring(htmlText, currentTutorialCharIndex) {
  let result = "";
  let tagBuffer = "";
  let inTag = false;
  let charCount = 0;

  for (let char of htmlText) {
    if (char === "<") {
      inTag = true;
      tagBuffer += char;
    } else if (char === ">" && inTag) {
      tagBuffer += char;
      result += tagBuffer;
      tagBuffer = "";
      inTag = false;
    } else if (inTag) {
      tagBuffer += char;
    } else {
      if (charCount < currentTutorialCharIndex) {
        result += char;
        charCount++;
      } else {
        break;
      }
    }
  }

  return result;
}
